import { render, staticRenderFns } from "./AutoAbnormal.vue?vue&type=template&id=d5a97d06&scoped=true&"
import script from "./AutoAbnormal.vue?vue&type=script&lang=js&"
export * from "./AutoAbnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a97d06",
  null
  
)

export default component.exports